import React from "react";

export default function PrivacyJamb() {
  return (
    <>
      <head>
        <title>Privacy Policy - Kinteron Jamb CBT Offline 2026</title>
        <style>
          {`
        body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          padding: 20px;
          max-width: 800px;
          margin: auto;
          background-color: #f4f4f4;
        }
        h1 {
          color: #333;
          text-align: center;
          margin-bottom: 20px;
        }
        h2 {
          color: #555;
          margin-top: 20px;
        }
        p, ul {
          color: #666;
        }
        ul {
          margin-left: 20px;
            list-style-type: circle;

          
        }
        strong {
          color: #333;
        }
          div {
          padding: 10px;
          }
        p {
          margin-bottom: 10px;
        }
          li {
          }
        a {
          color: #007BFF;
        }
      `}
        </style>
      </head>

      <div>
        <div>
          <div>
            <div>
              <h1>Privacy Policy for Kinteron Jamb CBT Offline 2026</h1>
              <div>Introduction</div>
              <div>
                Thank you for choosing to be part of our community at Kinteron
                Jamb CBT Offline 2026 (“Company”, “we”, “us”, or “our”). We are
                committed to protecting your personal information and your right
                to privacy. If you have any questions or concerns about our
                policy or our practices with regards to your personal
                information, please contact us at apostlegilead@gmail.com.{" "}
              </div>
              <div>
                {" "}
                When you visit our mobile application and use our services, you
                trust us with your personal information. We take your privacy
                very seriously. In this privacy policy, we seek to explain to
                you in the clearest way possible what information we collect,
                how we use it and what rights you have in relation to it. We
                hope you take some time to read through it carefully, as it is
                important. If there are any terms in this privacy policy that
                you do not agree with, please discontinue the use of our Apps
                and our services.{" "}
              </div>
              <div>
                {" "}
                This privacy policy applies to all information collected through
                our mobile application, (&apos;Apps&apos;), and/or any related
                services, sales, marketing or events (we refer to them
                collectively in this privacy policy as the
                &apos;Services&apos;). Please read this privacy policy carefully
                as it will help you make informed decisions about sharing your
                personal information with us.{" "}
              </div>
              <div>
                <div>1. &nbsp; What Information Do We Collect?</div>
                <div>2. &nbsp; How Do We Use Your Information?</div>
                <div>
                  {" "}
                  3. &nbsp; Will Your Information Be Shared With Anyone?{" "}
                </div>
                <div> 4. &nbsp; How Do We Handle Your Social Logins? </div>
                <div> 5. &nbsp; How Long Do We Keep Your Information? </div>
                <div> 6. &nbsp; How Do We Keep Your Information Safe? </div>
                <div>7. &nbsp; What Are Your Privacy Rights?</div>
                <div> 8. &nbsp; Controls For Do-not-track Features </div>
                <div> 9. &nbsp; Do We Make Updates To This Policy? </div>
                <div>
                  {" "}
                  10. &nbsp; How Can You Contact Us About This Policy?{" "}
                </div>
              </div>
              <div> 1. &nbsp; What Information Do We Collect? </div>
              <div>
                {" "}
                The personal information you disclose to us <br /> In Short: We
                collect personal information that you provide to us which is
                your email.{" "}
              </div>
              <div>
                {" "}
                We collect personal information that you voluntarily provide to
                us when registering at the Apps, expressing an interest in
                obtaining information about us or our products and services,
                when participating in activities on the Apps (such as posting
                messages in our online forums or entering competitions, contests
                or giveaways) or otherwise contacting us.{" "}
              </div>
              <div>
                {" "}
                The personal information that we collect depends on the context
                of your interactions with us and the Apps, the choices you make
                and the products and features you use. The personal information
                we collect can include the following:{" "}
              </div>
              <div>
                {" "}
                Publicly Available Personal Information. We collect only an
                email address.{" "}
              </div>
              <div>
                {" "}
                Credentials. We collect passwords, password hints, and similar
                security information used for authentication and account
                access.{" "}
              </div>

              <div>
                {" "}
                Information automatically collected In Short: Some information –
                such as IP address and/or browser and device characteristics –
                is collected automatically when you visit our Apps. We
                automatically collect certain information when you visit, use or
                navigate the Apps. This information does not reveal your
                specific identity (like your name or contact information) but
                may include device and usage information, such as your IP
                address, browser and device characteristics, operating system,
                language preferences, referring URLs, device name, country,
                location, information about how and when you use our Apps and
                other technical information. This information is primarily
                needed to maintain the security and operation of our Apps, and
                for our internal analytics and reporting purposes.{" "}
              </div>

              <div> 2. &nbsp; How Do We Use Your Information? </div>
              <div>
                {" "}
                In Short: We process your information for purposes based on
                legitimate business interests, the fulfillment of our contract
                with you, compliance with our legal obligations, and/or your
                consent. We use personal information collected via our Apps for
                a variety of business purposes described below. We process your
                personal information for these purposes in reliance on our
                legitimate business interests, in order to enter into or perform
                a contract with you, with your consent, and/or for compliance
                with our legal obligations. We indicate the specific processing
                grounds we rely on next to each purpose listed below.{" "}
              </div>
              <div>
                {" "}
                We use the information we collect or receive: To facilitate
                account creation and logon process. If you choose to link your
                account with us to a third party account (such as your Google or
                Facebook account), we use the information you allowed us to
                collect from those third parties to facilitate account creation
                and logon process for the performance of the contract. To send
                you marketing and promotional communications. We and/or our
                third-party marketing partners may use the personal information
                you send to us for our marketing purposes if this is in
                accordance with your marketing preferences. You can opt-out of
                our marketing emails at any time (see the &apos;WHAT ARE YOUR
                PRIVACY RIGHTS&apos; below).{" "}
              </div>
              <div>
                {" "}
                To send you marketing and promotional communications. We and/or
                our third-party marketing partners may use the personal
                information you send to us for our marketing purposes if this is
                in accordance with your marketing preferences. You can opt-out
                of our marketing emails at any time (see the &apos;WHAT ARE YOUR
                PRIVACY RIGHTS&apos; below).{" "}
              </div>
              <div>
                {" "}
                Fulfill and manage your orders. We may use your information to
                fulfill and manage your payments and returns made through the
                Apps.{" "}
              </div>

              <div>
                {" "}
                3. &nbsp; Will Your Information Be Shared With Anyone?{" "}
              </div>
              <div>
                {" "}
                In Short: We only share information with your consent, to comply
                with laws, to provide you with services, to protect your rights,
                or to fulfill business obligations.{" "}
              </div>
              <div>
                {" "}
                We may process or share data based on the following legal
                basis:{" "}
              </div>
              <div>
                {" "}
                Consent: We may process your data if you have given us specific
                consent to use your personal information for a specific
                purpose.{" "}
              </div>
              <div>
                {" "}
                Legitimate Interests: We may process your data when it is
                reasonably necessary to achieve our legitimate business
                interests.{" "}
              </div>
              <div>
                {" "}
                Performance of a Contract: Where we have entered into a contract
                with you, we may process your personal information to fulfill
                the terms of our contract.{" "}
              </div>
              <div>
                {" "}
                Legal Obligations: We may disclose your information where we are
                legally required to do so in order to comply with applicable
                law, governmental requests, a judicial proceeding, court order,
                or legal process, such as in response to a court order or a
                subpoena (including in response to public authorities to meet
                national security or law enforcement requirements).{" "}
              </div>
              <div>
                {" "}
                Vital Interests: We may disclose your information where we
                believe it is necessary to investigate, prevent, or take action
                regarding potential violations of our policies, suspected fraud,
                situations involving potential threats to the safety of any
                person and illegal activities, or as evidence in litigation in
                which we are involved. More specifically, we may need to process
                your data or share your personal information in the following
                situations: Vendors, Consultants, and Other Third-Party Service
                Providers. We may share your data with third-party vendors,
                service providers, contractors or agents who perform services
                for us or on our behalf and require access to such information
                to do that work. Examples include payment processing, data
                analysis, email delivery, hosting services, customer service,
                and marketing efforts. We may allow selected third parties to
                use tracking technology on the Apps, which will enable them to
                collect data about how you interact with the Apps over time.
                This information may be used to, among other things, analyze and
                track data, determine the popularity of certain content and
                better understand online activity. Unless described in this
                Policy, we do not share, sell, rent or trade any of your
                information with third parties for their promotional
                purposes.{" "}
              </div>
              <div>
                {" "}
                Business Transfers. We may share or transfer your information in
                connection with, or during negotiations of, any merger, sale of
                company assets, financing, or acquisition of all or a portion of
                our business to another company. Third-Party Advertisers. We may
                use third-party advertising companies to serve ads when you
                visit the Apps. These companies may use information about your
                visits to our Website(s) and other websites that are contained
                in web cookies and other tracking technologies in order to
                provide advertisements about goods and services of interest to
                you.{" "}
              </div>
              <div>
                {" "}
                Affiliates. We may share your information with our affiliates,
                in which case we will require those affiliates to honor this
                privacy policy. Affiliates include our parent company and any
                subsidiaries, joint venture partners or other companies that we
                control or that are under common control with us. <br />{" "}
                Business Partners. We may share your information with our
                business partners to offer you certain products, services or
                promotions.{" "}
              </div>

              <div> 5. &nbsp; How Long Do We Keep Your Information? </div>
              <div>
                {" "}
                In Short: We keep your information for as long as necessary to
                fulfill the purposes outlined in this privacy policy unless
                otherwise required by law. We will only keep your personal
                information for as long as it is necessary for the purposes set
                out in this privacy policy unless a longer retention period is
                required or permitted by law (such as tax, accounting or other
                legal requirements).{" "}
              </div>
              <div>
                {" "}
                No purpose in this policy will require us keeping your personal
                information for longer than When we have no ongoing legitimate
                business need to process your personal information, we will
                either delete or anonymize it, or, if this is not possible (for
                example, because your personal information has been stored in
                backup archives), then we will securely store your personal
                information and isolate it from any further processing until
                deletion is possible.{" "}
              </div>
              <div> 6. &nbsp; How Do We Keep Your Information Safe? </div>
              <div>
                {" "}
                In Short: We aim to protect your personal information through a
                system of organizational and technical security measures.{" "}
              </div>
              <div>
                {" "}
                We have implemented appropriate technical and organizational
                security measures designed to protect the security of any
                personal information we process. However, please also remember
                that we cannot guarantee that the internet itself is 100%
                secure. Although we will do our best to protect your personal
                information, the transmission of personal information to and
                from our Apps is at your own risk. You should only access the
                services within a secure environment.{" "}
              </div>
              <div> 7. &nbsp; What are your privacy rights? </div>
              <div>
                {" "}
                In Short: You may review, change, or terminate your account at
                any time.{" "}
              </div>
              <div>
                {" "}
                Account Information
                <br /> If you would at any time like to review or change the
                information in your account or terminate your account, you can:
                <br /> Contact us using the contact information provided. Upon
                your request to terminate your account, we will deactivate or
                delete your account and information from our active databases.
                However, some information may be retained in our files to
                prevent fraud, troubleshoot problems, assist with any
                investigations, enforce our Terms of Use and/or comply with
                legal requirements.{" "}
              </div>
              <div>
                {" "}
                Opting out of email marketing: You can unsubscribe from our
                marketing email list at any time by clicking on the unsubscribe
                link in the emails that we send or by contacting us using the
                details provided below. You will then be removed from the
                marketing email list – however, we will still need to send you
                service-related emails that are necessary for the administration
                and use of your account. To otherwise opt-out, you may:{" "}
              </div>
              <div> 8. &nbsp; Controls for DO-NOT-TRACK Features </div>
              <div>
                {" "}
                Most web browsers and some mobile operating systems and mobile
                applications include a Do-Not-Track (“DNT”) feature or setting
                you can activate to signal your privacy preference not to have
                data about your online browsing activities monitored and
                collected. No uniform technology standard for recognizing and
                implementing DNT signals has been finalized.{" "}
              </div>
              <div>
                {" "}
                As such, we do not currently respond to DNT browser signals or
                any other mechanism that automatically communicates your choice
                not to be tracked online. If a standard for online tracking is
                adopted that we must follow in the future, we will inform you
                about that practice in a revised version of this privacy
                policy.{" "}
              </div>
              <div> 9. &nbsp; Do we make updates to this policy? </div>
              <div>
                {" "}
                In Short: Yes, we will update this policy as necessary to stay
                compliant with relevant laws. We may update this privacy policy
                from time to time. The updated version will be indicated by an
                updated “Revised” date and the updated version will be effective
                as soon as it is accessible. If we make material changes to this
                privacy policy, we may notify you either by prominently posting
                a notice of such changes or by directly sending you a
                notification. We encourage you to review this privacy policy
                frequently to be informed of how we are protecting your
                information.{" "}
              </div>
              <div> 10. &nbsp; How can you contact us about this policy? </div>
              <div>
                {" "}
                If you have questions or comments about this policy, you may
                email us at apostlegilead@gmail.com{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
